import { useEffect } from "react";
import { copy } from "../copy";
import SiteFooter from "../components/SiteFooter";
import {
  Audience,
  ContestSteps,
  Faq,
  FinalCTA,
  Fees,
  GettingPaid,
  Hero,
  Judging,
  Mission,
  Picks,
  Refunds,
  Voting,
  Websites,
  WhatYouNeed,
} from "../howitworks/Sections";

// The whole platform in one read: contests, blind voting, judging, picks,
// payouts, websites, and refunds. Static copy only; it fetches nothing.
export default function HowItWorks() {
  useEffect(() => {
    document.title = copy.howPage.title;
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-ground font-sans text-chrome antialiased">
      <main>
        <Hero />
        <Mission />
        <ContestSteps />
        <Voting />
        <Judging />
        <Picks />
        <WhatYouNeed />
        <GettingPaid />
        <Fees />
        <Websites />
        <Refunds />
        <Audience />
        <Faq />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
